import { useQuery } from "@tanstack/react-query";
import apiClient from "../apiClient";

const fetchData = async (pageNumber, pageSize) => {
  const url = `api/Videos/recent?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  console.log(url);
  const { data } = await apiClient.get(url);
  console.log(data);
  return data;
};

const useGetYoutubeData = () => {
  return useQuery({
    queryKey: "videos",
    queryFn: () => fetchData(1, 9),
    staleTime: 1000 * 60 * 60 * 24, // Cache for 24 hours
    cacheTime: 1000 * 60 * 60 * 24, // Keep cache for 24 hours
  });
};

export default useGetYoutubeData;
